module.exports = __webpack_public_path__ + "static/img/dzj.684983a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/dzj.png
// module id = xsIW
// module chunks = 0